var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "sr-only",
        attrs: { "aria-live": "polite", "aria-atomic": "true" },
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.newsletter.title) +
            ", page " +
            _vm._s(_vm.currentPage) +
            " of " +
            _vm._s(_vm.pageCount) +
            "\n    "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5 mb-5 row" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary ml-4",
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [
            _c("i", {
              staticClass: "fas fa-ban",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Cancel"),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary ml-5",
            attrs: {
              disabled: _vm.currentPage <= 1,
              "aria-label":
                "Previous page, currently page " +
                _vm.currentPage +
                " of " +
                _vm.pageCount,
            },
            on: { click: _vm.prev },
          },
          [_vm._v("Previous")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("h1", [
          _vm._v(
            _vm._s(_vm.newsletter.title) +
              " - " +
              _vm._s(_vm.currentPage) +
              " / " +
              _vm._s(_vm.pageCount)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary ml-4",
            attrs: {
              disabled: _vm.currentPage == _vm.pageCount,
              "aria-label":
                "Next page, currently page " +
                _vm.currentPage +
                " of " +
                _vm.pageCount,
            },
            on: { click: _vm.next },
          },
          [_vm._v("Next")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pdfContainer" },
      [
        _c(
          "pdf",
          {
            attrs: { src: _vm.newsletter.pdfPath, page: _vm.currentPage },
            on: {
              numpages: function ($event) {
                _vm.pageCount = $event
              },
            },
          },
          [
            _c("template", { slot: "loading" }, [
              _c("div", { staticClass: "d-flex justify-content-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "spinner-border text-primary",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5 mb-5 row" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary ml-4",
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [
            _c("i", {
              staticClass: "fas fa-ban",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Cancel"),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary ml-5",
            attrs: {
              disabled: _vm.currentPage <= 1,
              "aria-label":
                "Previous page, currently page " +
                _vm.currentPage +
                " of " +
                _vm.pageCount,
            },
            on: { click: _vm.prev },
          },
          [_vm._v("Previous")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("h1", [
          _vm._v(
            _vm._s(_vm.newsletter.title) +
              " - " +
              _vm._s(_vm.currentPage) +
              " / " +
              _vm._s(_vm.pageCount)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary ml-4",
            attrs: {
              disabled: _vm.currentPage == _vm.pageCount,
              "aria-label":
                "Next page, currently page " +
                _vm.currentPage +
                " of " +
                _vm.pageCount,
            },
            on: { click: _vm.next },
          },
          [_vm._v("Next")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }